<script setup lang="ts">
const { isMobileOrTablet } = useResponsive()

const LINKS = [
  {
    id: 1,
    href: ' https://apps.apple.com/ru/app/id1158898682?referrer=appmetrica_tracking_id%3D818922990581394302%26ym_tracking_id%3D12865574045399502275',
    icon: './app-store-badge.svg',
    alt: 'Ссылка на приложение в AppStore',
  },
  {
    id: 2,
    href: ' https://play.google.com/store/apps/details?id=ru.farfor&referrer=appmetrica_tracking_id%3D170404690310291845%26ym_tracking_id%3D6050769962065580548',
    icon: './app-google-badge.svg',
    alt: 'Ссылка на приложение в GooglePlay',
  },
]
</script>

<template>
  <div class="app-factoid">
    <div class="app-factoid__info">
      <span class="app-factoid__title">
        Заказывай в приложении и получи пиццу в подарок!
      </span>

      <p class="app-factoid__text">
        Пицца «Мясная» 25 см в подарок при заказе через приложение! Подробности
        при скачивании:
      </p>

      <the-button
        v-if="isMobileOrTablet"
        href="https://farfor.ru/a/"
        rel="nofollow"
        variant="secondary"
        radius="lg"
        block
      >
        <span>Скачать</span>
      </the-button>

      <div v-else class="app-factoid__links">
        <a
          v-for="link in LINKS"
          :key="link.id"
          :href="link.href"
          rel="nofollow"
          class="app-factoid__link"
        >
          <nuxt-img
            :src="link.icon"
            :alt="link.alt"
            loading="lazy"
            width="128"
            height="40"
          />
        </a>
      </div>
    </div>

    <div class="app-factoid__qr">
      <p class="app-factoid__qr-description">
        Наведите камеру на QR-код, чтобы скачать
      </p>

      <nuxt-img
        src="/app-qr.webp"
        alt="qr код приложения"
        width="124"
        height="124"
        loading="lazy"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-factoid {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 334px;
  padding: 60px;
  color: var(--ui-white);
  background:
    url('@/assets/images/main-factoid-background.webp') no-repeat right 200px
      bottom,
    linear-gradient(90deg, var(--ui-primary) 0%, #ff6e1d 100%);
  border-radius: 40px;

  @include media('<desktop-mini') {
    padding: 30px;
    background-position: right -50px bottom;
  }

  @include media('<tablet') {
    height: max-content;
    background:
      linear-gradient(90deg, var(--ui-primary) 0%, #ff6e1d 100%), none;
    border-radius: 20px;
  }

  &__info {
    max-width: 450px;

    @include media('<desktop-mini') {
      max-width: 40%;
    }

    @include media('<tablet') {
      max-width: 100%;
    }
  }

  &__links {
    display: flex;
    gap: 25px;
  }

  &__title {
    margin-bottom: 25px;
    font-size: 32px;
    font-weight: 900;
    line-height: 38px;

    @include media('<desktop-mini') {
      display: block;
      margin-bottom: 20px;
      font-size: 20px;
      line-height: 23px;
    }
  }

  &__text {
    margin-bottom: 25px;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;

    @include media('>=tablet') {
      font-size: 16px;
      line-height: 19px;
    }
  }

  &__qr {
    max-width: 160px;

    @include media('<desktop-mini') {
      display: none;
    }

    &-description {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 600;
      line-height: 19px;
    }
  }
}
</style>
